import { render, staticRenderFns } from "./About.vue?vue&type=template&id=1ae8a7be&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../Users/pongping/htdocs/ufs896@vip/eagleway/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports